"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _get = _interopRequireDefault(require("lodash/get"));
var _UiContext = _interopRequireDefault(require("../context/UiContext"));
var _PageContext = _interopRequireDefault(require("../context/PageContext"));
var _useIsScrolling = _interopRequireDefault(require("../hooks/useIsScrolling"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useSetting = config => {
  const [result, setResult] = (0, _react.useState)({});
  const [ui] = (0, _react.useContext)(_UiContext.default);
  const {
    _settings
  } = ui;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    layoutTag,
    layoutVariant
  } = pageData;
  const {
    identifier,
    layout = false,
    layoutScroll = false,
    breakpoints = false
  } = config;
  const isScrolling = (0, _useIsScrolling.default)();
  const theme = (0, _useTheme.default)();
  const isXS = (0, _useMediaQuery.default)(theme.breakpoints.only("xs"));
  const isSM = (0, _useMediaQuery.default)(theme.breakpoints.only("sm"));
  const isMD = (0, _useMediaQuery.default)(theme.breakpoints.only("md"));
  const isLG = (0, _useMediaQuery.default)(theme.breakpoints.only("lg"));
  const isXL = (0, _useMediaQuery.default)(theme.breakpoints.only("xl"));
  (0, _react.useEffect)(() => {
    const rootObject = JSON.parse(JSON.stringify((0, _get.default)(_settings, identifier)));
    let currentObject = rootObject;
    try {
      if (layout) {
        let currentLayoutString = "";
        if (layout && !layoutVariant && !layoutScroll) {
          currentLayoutString = layoutTag;
        } else if (layout && layoutVariant && !layoutScroll) {
          currentLayoutString = "".concat(layoutTag, "-").concat(layoutVariant);
        } else if (layout && layoutVariant && layoutScroll) {
          if (isScrolling) {
            currentLayoutString = "".concat(layoutTag, "-").concat(layoutVariant, "--scroll");
          } else {
            currentLayoutString = "".concat(layoutTag, "-").concat(layoutVariant);
          }
        } else if (layout && !layoutVariant && layoutScroll) {
          if (isScrolling) {
            currentLayoutString = "".concat(layoutTag, "--scroll");
          } else {
            currentLayoutString = "".concat(layoutTag);
          }
        }
        currentObject = (0, _get.default)(currentObject, currentLayoutString);
      }
      if (breakpoints) {
        if (!currentObject.xs) return;
        if (!currentObject.sm) {
          currentObject.sm = currentObject.xs;
        }
        if (!currentObject.md) {
          currentObject.md = currentObject.sm;
        }
        if (!currentObject.lg) {
          currentObject.lg = currentObject.md;
        }
        if (!currentObject.xl) {
          currentObject.xl = currentObject.lg;
        }
        if (isXS) currentObject = currentObject.xs;
        if (isSM) currentObject = currentObject.sm;
        if (isMD) currentObject = currentObject.md;
        if (isLG) currentObject = currentObject.lg;
        if (isXL) currentObject = currentObject.xl;
      }
    } catch (error) {
      console.error(error);
    }
    setResult(currentObject || {});
  }, [identifier, layout, layoutScroll, breakpoints, _settings, layoutVariant, isScrolling, layoutTag, theme, isXS, isSM, isMD, isLG, isXL]);
  return result;
};
var _default = exports.default = useSetting;